<template>
  <div >
    <div style="width:80%">
      <el-collapse v-model="activeNames" @change="handleChange" accordion>
        <el-collapse-item title="In-Hall Operation Schedule " name="1">
          <div>
            <el-table :data="tableData" style="width: 100%"> 
              <el-table-column   prop="name"   label="Assembly Period"   width="220"> </el-table-column> 
              <el-table-column   prop="date"   label="Date "   width="220"> </el-table-column> 
              <el-table-column   prop="time"   label="Time"> </el-table-column>
            </el-table>

            <el-table :data="tableData1" style="width: 100%"> 
              <el-table-column   prop="name"   label="Exhibition Period"   width="220">
                
              </el-table-column> 
              <el-table-column   prop="date"   label="Date "   width="220">
                <template slot-scope="scope"><div v-html="scope.row.date"></div></template>
              </el-table-column> 
              <el-table-column   prop="time"   label="Time">
                <template slot-scope="scope"><div v-html="scope.row.time"></div></template>
              </el-table-column>
            </el-table>

            <el-table :data="tableData2" style="width: 100%"> 
              <el-table-column   prop="name"   label="Dismantling Period"   width="220"> </el-table-column> 
              <el-table-column   prop="date"   label="Date "   width="220"> </el-table-column> 
              <el-table-column   prop="time"   label="Time"> </el-table-column>
            </el-table>

            <div class="tip">
              <p>Note:</p>
              <p><span>a.</span>The various dates and times listed above will be strictly enforced. Exhibitors are advised to the abovementioned times and dates.</p>
              <p><span>b.</span>Exhibits may be delivered to the stand earlier than the time specified if construction (in the case of ‘Raw Space only’ stands) has progressed sufficiently to receive the exhibits. Please liaise with the Official Freight Forwarder for such arrangements. Exhibitors must be present to receive such exhibits.</p>
              <p><span>c.</span>Exhibitors are advised to commence packing their exhibits and belongings as soon as the Exhibition ends on the last day. Arrangements with the freight forwarders will have to be made in advance. Dismantling of certain Shell Scheme stands will commence immediately upon Exhibition closure. Exhibitors are advised to remove any displays from the walls that they wish to retain.</p>
              <p><span>d.</span> Exhibitors are permitted to enter the Exhibition area half an hour before opening time and remain not more than half an hour after the closing time during the Exhibition days. Exhibitors and their staff are requested to be present at their stands at least 15 minutes before the opening hours of the Exhibition.</p>
              <p><span>e.</span> The audience will stop entering the hall at 2 pm on 30 August; The power will be cut off at 3 pm.</p>
              <p>This schedule is correct at the time of printing. Should there be any amendments, an updated copy will be available at the Organizer’s Office on-site.</p>
            </div>

          </div>
        </el-collapse-item>
         
        <el-collapse-item title="Helpful Contact List" name="2">
          <div class="lxWarp">
            <div class="item">
                <div class="itemTitle">General Contact(Organizer)</div>
                <div>
                    <p class="smallTtiel">CFNA (China Chamber of Commerce of Import & Export of Foodstuffs, Native Produce & Animal By-Products)</p>
                    <p>Contact: Ms. Wei Na</p>
                    <P>Tel: (86)10-87109840</P>
                    <p>Email: weina@cccfna.org.cn</p>

                    <p class="smallTtiel">CFMA (The China Fruit Marketing Association)</p>
                    <p>Contact: Mr. Ti Wenzan</p>
                    <p>Tel: 15011505934</p>
                </div>
            </div>

            <div class="item">
                <div class="itemTitle">General Contact (Co – organizer)</div>
                <div>
                    <p class="smallTtiel">Shanghai EverFlourish Events Co.,Ltd. </p>
                    <p>No. 55, West Huaihai Road, Shentong Plaza, Xuhui District, Shanghai</p>
                    <p>Contact: Ivy Lin、Jessica Wei</p>
                    <P>Tel: 19301254949<br/>18501685932</P>
                    <p>Email:ivy.lin@fruitexpo.cn<br/>jessica.wei@fruitexpo.cn</p>
                </div>
            </div>


            <div class="item">
                <div class="itemTitle">Fair Ground</div>
                <div>
                    <p class="smallTtiel">Shanghai New International Expo Centre Co., Ltd.</p>
                    <p>2345 Long yang Road,Shanghai 201204, China</p>
                    <p>Tel: (86) 21 2890 6888</p>
                    <P>Fax: (86) 21 2890 6866</P>
                    <P>Email: info@sniec.net</P>
                    <P>Website: www.sniec.net</P>
                </div>
            </div>


            <div class="item">
                <div class="itemTitle">Official Freight Forwarder</div>
                <div>
                    <p class="smallTtiel">Shanghai Rogers Exhibition Services Ltd.</p>
                    <p>Room 1803, Block A, New Century Plaza, No. 48 Xing Yi road, Shanghai 200336 China</p>
                    <P>Contact: Ren Yonggang / Liang Xinwang</P>
                    <p>Tel: (86) 21 6270 0003</p>
                    <P>Fax: (86) 21 6270 0005</P>
                    <p>Email: info@rogerssha.com</p>
                </div>
            </div>

         

            <div class="item">
                <div class="itemTitle">Official Stand Contractor</div>
                <div>
                    <p class="smallTtiel">Shanghai Chuangyu Exhibition Co., Ltd</p>
                    <p>Contact : Mr.Wang Daowei</p>
                    <P>Tel:19921238017</P>
                    <P>Email: cyexpo@vip.163.com</P>
                </div>
            </div>

            

            <div class="item">
                <div class="itemTitle">Raw Space construction review and supervision unit</div>
                <div>
                    <p class="smallTtiel">OptSafe Management Services (Shanghai) Limited</p>
                    <p>Contact : Mr.Hu Weizhen / Mr.Ge Weichao</p>
                    <P>Tel:21-69957319/7316</P>
                    <P>Email: CIFE@opt-safe.com</P>
                </div>
            </div>

            <div class="item">
                <div class="itemTitle">Official Insurance Agent</div>
                <div>
                    <p class="smallTtiel">Taiping Property Insurance Co., Ltd. Shanghai Branch</p>
                    <p>Exhibition Risk Management Manager</p>
                    <P>Contact : Mr. Li Xin / Ms. Chen WeiJun</P>
                    <P>Tel: (86) 21-51113250<br/>18217731507、18217730796</P>
                </div>
            </div>

            


            <div class="item">
                <div class="itemTitle">Official Travel Agency</div>
                <div>
                    <p class="smallTtiel">Orient Event Service</p>
                    <p>Contact: Mr. Seven Liu</p>
                    <P>Tel: +86 21 51099795<br/>17321367242</P>
                    <P>Email: booking@orient-explorer.com.cn</P>
                </div>
            </div>

            <div class="item">
                <div class="itemTitle">Building Approval Company</div>
                <div>
                    <p class="smallTtiel">HAH Consulting & Exhibition Co.Ltd.Shanghai</p>
                    <p>E2-2E1,2345 Longyang Rd, Shanghai, China</p>
                    <P>Contact : Ms. Kim Gu</P>
                    <P>Tel: (86) 21 28906633/34/35*809</P>
                    <p>Fax:(86) 21 28906000</p>
                    <p>Email: hah@hahchina.com</p>
                </div>
            </div>

          </div>
        </el-collapse-item>

      </el-collapse>
    </div>
    <div style="display:flex;padding-top:20px">
      <div style="margin-right:50px"><el-button type="primary" ><a :href="demoExcel" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">General Information.pdf</a></el-button></div>
      <div><el-button type="primary" ><a :href="demoExcel1" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">Rules and Regulations.pdf</a></el-button></div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ExhNotice',
  data: () => ({
      demoExcel:'./General Information.pdf',
      demoExcel1:'./Rules and Regulations.pdf',
      activeNames:['1','2'],
      tableData: [{
        date: '26-27 August 2024',
        name: 'Construction, Installation and Exhibits Moving-in',
        time: '09:00-22:00'
      }, {
        date: '26-27 August 2024',
        name: 'Exhibitor Registration (for Raw Space)',
        time: '09:00-17:30'
      }, {
        date: '27 August 2024',
        name: 'Exhibitor Registration (for Shell Scheme)',
        time: '09:00-17:30'
      }],
      tableData1: [{
        date: '28-29 August 2024<br/>30 August 2024',
        name: 'Opening Hours of Exhibition',
        time: '09:00-17:30<br/>09:00-15:00'
      }],
      tableData2: [{
        date: '30 August 2024',
        name: 'Return of all Rented Items<br/>(telephones, furniture, electric sockets, etc)',
        time: '16:00-17:30'
      }, {
        date: '30 August 2024',
        name: 'Removal of Exhibits',
        time: '15:00-22:00'
      }, {
        date: '30 August 2024',
        name: 'Complete Dismantling of Pavilions and Booths ',
        time: '22:00'
      }]
        
  }),
  components: {

  },
  methods: {
    handleChange(val) {
        console.log(val);
      }
  }
}
</script>
<style lang="less" scope>
.el-collapse-item__header{
  font-weight: bold !important;
  font-size: 16px;
}
.tip{
  font-size: 14px;
  padding:20px 10px;
}
.tip p{
  display: flex;
}
.tip p span{
  margin-right: 8px;
}
.lxWarp{
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
}
.lxWarp .item{
 border: 1px solid #EBEEF5;
 padding: 10px;
 margin-bottom: 10px;
 width: 30%;
 margin-right: 2%;
}
.lxWarp .item .itemTitle{
  font-weight: bold;
  font-size: 16px;
  padding: 4px 0;
}
.lxWarp .item .smallTtiel{
  font-weight: bold;
  font-size: 14px;
}
</style>
